<script>
export default {
  name: 'AdminErrors',
  props: {
    errors: Array
  },
  data() {
    return {
      dialogError: {},
      dialogVisible: false
    };
  },
  methods: {
    deleteError(error) {
      this.$http.delete(`/admin/errors/${error.id}`)
        .then(() => this.$emit('deleted', error))
        .catch(err => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: err.message
          });
        });
    },

    showError(error) {
      this.dialogError = error;
      this.dialogVisible = true;
    }
  }
};
</script>

<template>
  <div class="errors">
    <table v-if="errors.length" class="table">
      <thead>
        <th>Date</th>
        <th>Status</th>
        <th class="hidden-sm-and-down">Method</th>
        <th class="hidden-sm-and-down">URL</th>
        <th class="hidden-sm-and-down">IP</th>
        <th />
      </thead>
      <tbody>
        <tr v-for="error in errors" :key="error.id">
          <td>{{ $d(new Date(error.createdAt), 'medium') }}</td>
          <td><span :data-status-code="error.statusCode">{{ error.statusCode }}</span></td>
          <td class="hidden-sm-and-down">{{ error.method }}</td>
          <td class="hidden-sm-and-down">{{ error.url }}</td>
          <td class="hidden-sm-and-down">{{ error.remoteAddress }}</td>
          <td>
            <el-button size="small" @click="showError(error)">
              Details
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="no-errors">
      No Errors
    </div>

    <!-- Error dialog -->
    <el-dialog
      :visible.sync="dialogVisible"
      title="Error Details"
      class="error-dialog el-dialog--large"
    >
      <pre>{{ dialogError.details }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button
          type="danger"
          @click="deleteError(dialogError); dialogVisible = false"
        >
          Delete
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.errors {
  [data-status-code] {
    border-radius: .125rem;
    padding: .125rem .25rem;

    // 400 errors
    &[data-status-code^="4"] {
      background-color: $--color-warning;
      color: white;
    }

    // 500 errors
    &[data-status-code^="5"] {
      background-color: $--color-danger;
      color: white;
    }
  }
}

.no-errors {
  font-size: 1.2rem;
  text-align: center;
  color: $--color-gray-40;
  padding: 5rem 0;
}

.error-dialog {
  /deep/ pre {
    background: $--color-gray-90;
    border-radius: .25rem;
    font-family: $--font-family-monospace;
    font-size: $--font-size-small;
    color: $--color-white;
    padding: 1rem;
    overflow: auto;

    mark.error-gray {
      background-color: transparent;
      color: $--color-gray-50;
    }
  }
}
</style>
